import type { ReactNode } from "react"
import { ChatVisibilityProvider } from "./ChatVisibilityContext"
import { ChatMessagesProvider } from "./ChatMessagesContext"
import { ChatInputProvider } from "./ChatInputContext"
import { ChatLoadingProvider } from "./ChatLoadingContext"
import { DocsetProvider } from "./DocsetContext"

interface ChatProviderProps {
  children: ReactNode
  initialDocset?: string
  defaultChatOpen?: boolean
  onDocsetChange?: (oldDocset: string, newDocset: string) => void
}

export function ChatProvider({ 
  children, 
  initialDocset = "tourvisio",
  defaultChatOpen = false,
  onDocsetChange
}: ChatProviderProps) {
  return (
    <DocsetProvider 
      initialDocset={initialDocset}
      onDocsetChange={onDocsetChange}
    >
      <ChatVisibilityProvider defaultOpen={defaultChatOpen}>
        <ChatMessagesProvider>
          <ChatInputProvider>
            <ChatLoadingProvider>
              {children}
            </ChatLoadingProvider>
          </ChatInputProvider>
        </ChatMessagesProvider>
      </ChatVisibilityProvider>
    </DocsetProvider>
  )
}

export { useChatVisibility } from "./ChatVisibilityContext"
export { useChatMessages } from "./ChatMessagesContext"
export { useChatInput } from "./ChatInputContext"
export { useChatLoading } from "./ChatLoadingContext"
export { useDocset } from "./DocsetContext"

export type { ChatVisibilityContextType } from "./ChatVisibilityContext"
export type { ChatMessagesContextType } from "./ChatMessagesContext"
export type { ChatInputContextType } from "./ChatInputContext"
export type { ChatLoadingContextType, ChatStatus } from "./ChatLoadingContext"
export type { DocsetContextType } from "./DocsetContext" 